<template>
  <div v-loading="loading">
    <ContentHeader :material-nav="false" />
    <div class="content-container">
      <ItemOrderBudgetPicker item-type="03" @setValue="onBudgetPickerChanged" />

      <el-row class="non-menu-less less-first-row">
        <el-col class="upload-certificate-col">
          <el-upload
            ref="uploadCertificate"
            :action="fileUploadTarget"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :before-remove="handleFileRemove"
          >
            <el-button class="btn-red-plain" type="primary" plain>上传比价凭证</el-button>
          </el-upload>
        </el-col>
        <el-col class="non-menu-item entity-picker-col" type="flex" align="center">
          <ItemOrderEntityPicker @setValue="onEntityPickerChanged" />
        </el-col>
      </el-row>

      <!-- 订单描述 -->
      <el-row class="non-menu-desc">
        <el-col :span="3">
          <span class="required-text">*</span>订单描述
        </el-col>
        <el-col :span="9">
          <el-input placeholder="请填写订单描述" style="margin-top: -15px" v-model="orderForm.purchaseOrder.orderDesc" maxlength="20"></el-input>
        </el-col>
      </el-row>

      <!-- 填写订单信息 -->
      <el-row class="non-menu-less">
        <el-col class="item-info-box">
          <el-col class="item-submit-way">
            <span class="item-info-title">提交申请方式</span>
            <el-radio-group class="submit-way-radio" v-model="uploadType" @change="submitWayChange">
              <el-radio :label="0">在线填写</el-radio>
              <el-radio :label="1">上传模板</el-radio>
            </el-radio-group>
            <template v-if="uploadType === 1">
              <el-button class="btn-blue-plain template-btn" type="primary" plain @click="downloadTemplate">
                <i class="iconfont iconzu22" />
                下载订单模板
              </el-button>

              <FileUpload
                ref="uploadOrderTemplate"
                :upload-param="{ filePath: 'temp' }"
                show-type="text"
                @uploaded="getDataFile"
                @removed="clearDataFile"
                :isClearFile="isClear"
              >
                <el-button class="btn-blue-plain template-btn" type="primary" plain>
                  <i class="iconfont iconzu111" />
                  上传订单模板文件（批量导入）
                </el-button>
              </FileUpload>
            </template>
          </el-col>
          <el-col class="item-info-form">
            <!-- <el-row class="info-form-head">
              <el-col :span="3">物料编码</el-col>
              <el-col :span="3">品牌</el-col>
              <el-col :span="3">物料名称</el-col>
              <el-col class="info-form-unit" :span="1">单位</el-col>
              <el-col class="info-form-price" :span="2">单价<br>(含税)</el-col>
              <el-col :span="2">数量</el-col>
              <el-col class="info-form-produce" :span="3">供应商名称</el-col>
              <el-col :span="3">交货地址</el-col>
              <el-col :span="3">操作</el-col>
            </el-row>-->
            <el-row :gutter="10" class="info-form-detail" v-for="(item, index) in deliveryList" :key="index">
              <el-col :span="4">
                <div class="table-input-row">
                  <span class="require-text">*</span>物料编码
                </div>
                <el-select
                  v-if="uploadType === 0"
                  v-model="deliveryList[index].itemCode"
                  :disabled="uploadType === 1"
                  placeholder="选择编码"
                  style="width:100%"
                  clearable
                >
                  <el-option v-for="item in NonMenuCodeList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                </el-select>
                <el-input v-else v-model="deliveryList[index].itemCode" :disabled="uploadType === 1"></el-input>
              </el-col>
              <el-col :span="4">
                <div class="table-input-row">
                  <span class="require-text">*</span>物料名称
                </div>
                <el-input v-model="deliveryList[index].itemName" :disabled="uploadType === 1" clearable></el-input>
              </el-col>
              <el-col :span="2">
                <div class="table-input-row">
                  <span class="require-text">*</span>单价(不含税)
                </div>
                <el-input-number v-model="deliveryList[index].purchasePrice" :disabled="uploadType === 1" clearable @blur="checkPurchasePrice(deliveryList[index].purchasePrice,index)"></el-input-number>
              </el-col>
              <el-col :span="2">
                <div class="table-input-row">
                  <span class="require-text">*</span>单位
                </div>
                <el-select
                  v-if="uploadType === 0"
                  v-model="deliveryList[index].itemUnit"
                  :disabled="uploadType === 1"
                  placeholder="选择单位"
                  style="width:100%"
                  filterable
                  clearable
                >
                  <el-option v-for="(item, index) in unitList" :key="index" :label="`${item.unit}-${item.desc}`" :value="item.unit"></el-option>
                </el-select>
                <el-input v-else v-model="deliveryList[index].itemUnit" :disabled="uploadType === 1" clearable></el-input>
              </el-col>
              <!-- <el-col :span="2">
                <div class="table-input-row">
                  <span class="require-text">*</span>数量
                </div>
                <el-input v-model="deliveryList[index].purchaseQuantity" @blur="checkQty" :disabled="uploadType === 1" clearable></el-input>
              </el-col>-->
              <el-col :span="3">
                <div class="table-input-row">
                  <span class="require-text">*</span>MMR12
                </div>
                <el-select
                  v-if="uploadType === 0"
                  v-model="deliveryList[index].mmr12"
                  :disabled="uploadType === 1"
                  clearable
                  placeholder="选择MMR12"
                  @change="mmrInput(index)"
                >
                  <el-option
                    v-for="item in mmr12List"
                    :key="item.mmr12Id"
                    :label="`${item.mmr12Code}-${item.mmr12Name}`"
                    :value="item.mmr12Code"
                    :title="`${item.mmr12Code}-${item.mmr12Name}`"
                    style="max-width: 400px"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="deliveryList[index].mmr12" :disabled="uploadType === 1" clearable></el-input>
              </el-col>
              <el-col :span="4">
                <div class="table-input-row">
                  <span class="require-text">*</span>总账科目
                </div>
                <el-select
                  v-model="deliveryList[index].ledgerAccount"
                  :disabled="uploadType === 1"
                  placeholder="选择总账科目"
                  style="width:100%"
                  clearable
                >
                  <el-option
                    v-for="item in deliveryList[index].ledgerList"
                    :key="item.ledgerAccountCode"
                    :label="`${item.ledgerAccountCode}-${item.ledgerAccountName}`"
                    :value="item.ledgerAccountCode"
                    :title="`${item.ledgerAccountCode}-${item.ledgerAccountName}`"
                    style="max-width: 400px"
                  ></el-option>
                </el-select>
              </el-col>

              <!-- <el-col :span="3" type="flex" justify="center" align="center"> -->

              <!-- <el-button
                  v-if="uploadType === 0"
                  class="btn-blue-plain"
                  type="primary"
                  size="small"
                  plain
                  @click="selectAdress(index)">
                  {{ deliveryList[index].receivePerson ? '收货人：' + deliveryList[index].receivePerson + '，···' : '从地址簿中选择' }}
              </el-button>-->

              <!-- <div class="table-input-row">
                  <span class="require-text">*</span>交货地址
                </div>
                <div v-if="uploadType === 0">
                  <el-cascader v-model="sdAddress[index]" :options="addressOptions" :props="{ expandTrigger: 'hover' }" clearable />
                </div>
                <div v-else class="info-form-detail" :title="deliveryList[index].addressInfo">
                  {{ deliveryList[index].addressInfo }}
                </div>
              </el-col>-->

              <el-col :span="3" class="btn-function">
                <el-button
                  :disabled="uploadType === 1"
                  class="btn-blue-plain add-col-btn"
                  type="primary"
                  size="small"
                  plain
                  @click="handleAddForm"
                >新增</el-button>
                <el-button
                  :disabled="uploadType === 1"
                  class="btn-blue-plain delete-col-btn"
                  type="danger"
                  size="small"
                  plain
                  @click="handleDeleteForm(index)"
                  v-if="deliveryList.length > 1"
                >删除</el-button>
              </el-col>
              <el-col :span="5">
                <div class="table-input-row">
                  <span class="require-text">*</span>品牌及子品牌
                </div>
                <!-- <el-select v-if="uploadType === 0" v-model="deliveryList[index].abiBrandName" placeholder="选择品牌" style="width: 100%" clearable>
                  <el-option
                    v-for="item in brandList"
                    :key="item.abiBrandId"
                    :label="item.abiBrandName"
                    :value="item.abiBrandName">
                  </el-option>
                </el-select>-->
                <el-cascader
                  v-if="uploadType === 0"
                  v-model="deliveryList[index].brand"
                  placeholder="选择品牌"
                  :options="brandList"
                  :props="brandProps"
                  style="width: 100%"
                  clearable
                ></el-cascader>
                <div
                  v-else
                  class="info-form-input"
                  :title="`${deliveryList[index].abiBrandName}/${deliveryList[index].subBrandName}`"
                >{{ `${deliveryList[index].abiBrandName}/${deliveryList[index].subBrandName}` }}</div>
                <!-- <el-input v-else v-model="deliveryList[index].abiBrandName" :disabled="uploadType === 1"></el-input> -->
              </el-col>
              <!-- <el-col :span="3">
                <div class="table-input-row">
                  <span class="require-text">*</span>渠道类型
                </div>
                <el-select v-if="uploadType === 0" v-model="deliveryList[index].mmr12Type" placeholder="渠道类型">
                  <el-option
                    v-for="item in channelTypeList"
                    :key="item.channelTypeId"
                    :label="item.channelTypeName"
                    :value="item.channelTypeId">
                  </el-option>
                </el-select>
                <el-input v-else v-model="deliveryList[index].mmr12Type" :disabled="uploadType === 1"></el-input>
              </el-col>-->
              <el-col :span="5">
                <div class="table-input-row">
                  <span class="require-text">*</span>渠道及子渠道
                </div>
                <el-cascader
                  v-if="uploadType === 0"
                  v-model="deliveryList[index].channel"
                  placeholder="选择渠道"
                  :options="channelList"
                  :props="channelProps"
                  style="width: 100%"
                  clearable
                ></el-cascader>
                <div
                  v-else
                  class="info-form-input"
                  :title="`${deliveryList[index].channelName}/${deliveryList[index].subChannelName}`"
                >{{ `${deliveryList[index].channelName}/${deliveryList[index].subChannelName}` }}</div>
                <!-- <el-input v-else v-model="deliveryList[index].channelName" :disabled="uploadType === 1"></el-input> -->
              </el-col>
              <el-col :span="3">
                <div class="table-input-row">
                  <span class="require-text">*</span>科目分配类别
                </div>
                <el-select
                  v-model="pocmList[index].subjectCategory"
                  :disabled="uploadType === 1"
                  placeholder="选择科目分配类别"
                  style="width:100%"
                  clearable
                >
                  <el-option v-for="item in subjectCategoryList" :key="item.value" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <div class="table-input-row">
                  <span class="require-text">*</span>税码
                </div>
                <el-select clearable filterable v-if="uploadType === 0" v-model="pocmList[index].taxCode" placeholder="选择税码">
                  <el-option v-for="item in taxRateList" :key="item.key" :label="`${item.key}：${item.value}`" :value="item.key"></el-option>
                </el-select>
                <el-input v-else v-model="pocmList[index].taxCode" :disabled="uploadType === 1"></el-input>
              </el-col>
              <!-- <el-col :span="3">
                <div class="table-input-row">
                  <span class="require-text">*</span>交货日期
                </div>
                <el-date-picker
                  :disabled="uploadType === 1"
                  class="date-selection"
                  v-model="deliveryList[index].expectReceiveDate"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions" clearable>
                </el-date-picker>
                <el-input v-else v-model="deliveryList[index].expectReceiveDate" disabled></el-input>
              </el-col>-->
              <el-col :span="2">
                <div class="table-input-row">
                  <span class="require-text">*</span>申请人
                </div>
                <el-input v-model="deliveryList[index].applyPerson" :disabled="uploadType === 1" clearable></el-input>
              </el-col>
              <el-col :span="2">
                <div class="table-input-row">
                  <span class="require-text">*</span>M3
                </div>
                <el-input v-model="deliveryList[index].m3Person" :disabled="uploadType === 1" clearable></el-input>
              </el-col>

              <el-col :span="9">
                <div class="table-input-row">
                  <span class="require-text">*</span>供应商名称
                </div>
                <el-select
                  style="width: 100%"
                  clearable
                  filterable
                  v-if="uploadType === 0"
                  v-model="pocmList[index].produceSupplierName"
                  placeholder="选择供应商"
                >
                  <el-option
                    v-for="item in produceSupplierList"
                    :key="item.supplierId"
                    :label="item.supplierName"
                    :value="item.supplierName"
                  ></el-option>
                </el-select>
                <el-input v-else v-model="pocmList[index].produceSupplierName" :disabled="uploadType === 1"></el-input>
              </el-col>
              <el-col :span="16">
                <div class="table-input-row" v-if="uploadType === 1">
                  <span class="require-text">*</span>交货地址
                  <span class="create-text" @click="toAdd">新建地址</span>
                </div>
                <!-- <el-cascader style="width:100%" v-model="deliveryList[index].addressId" :options="addressOptions" :props="{ expandTrigger: 'hover' }" clearable /> -->
                <div v-if="uploadType === 0">
                  <div style="display:flex" v-for="address,addrIndex in  item.addressList" :key="addrIndex">
                    <div>
                      <div class="table-input-row">
                        <span class="require-text">*</span>
                        交货地址{{addrIndex + 1}}
                        <span class="create-text" @click="toAdd">新建地址</span>
                      </div>
                      <el-select style="width: 600px" clearable filterable v-model="address.clientAddressId" placeholder="选择交货地址">
                        <el-option
                          v-for="item in addressList"
                          :key="item.addressId"
                          :label="`${item.provinceName}-${item.cityName}-${item.countyName}-${item.detailAddress}，收货人：${item.contactPerson} ${item.contactMobile}`"
                          :value="item.addressId"
                        ></el-option>
                      </el-select>
                    </div>
                    <div>
                      <div class="table-input-row">
                        <span class="require-text">*</span>数量
                      </div>
                      <div style="display:flex">
                        <el-input-number
                          class="Stepper"
                          style="width:110px;margin-right: 25px;"
                          v-model="address.purchaseQuantity"
                          placeholder="填写物料数量"
                          :min="1"
                        ></el-input-number>
                        <span
                          class="danger-btn el-icon-remove-outline"
                          @click="delAddress(index,addrIndex)"
                          v-if="item.addressList.length > 1"
                        ></span>
                        <span class="addAddress el-icon-circle-plus-outline" @click="addAddress(index)"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="info-form-input"
                  :title="deliveryList[index].provinceName ? `${deliveryList[index].provinceName}-${deliveryList[index].cityName}-${deliveryList[index].countyName}-${deliveryList[index].detailAddress}，收货人：${deliveryList[index].receivePerson} ${deliveryList[index].receivePhone}` : ''"
                >{{ deliveryList[index].provinceName ? `${deliveryList[index].provinceName}-${deliveryList[index].cityName}-${deliveryList[index].countyName}-${deliveryList[index].detailAddress}，收货人：${deliveryList[index].receivePerson} ${deliveryList[index].receivePhone}` : '' }}</div>
              </el-col>
              <el-col :span="24" v-if="deliveryList.length > 1">
                <div class="split-line"></div>
              </el-col>
            </el-row>
            <div class="pag-row pagination" v-if="uploadType === 1">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="page"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
          </el-col>
        </el-col>
      </el-row>

      <!-- <el-row class="non-menu-less non-menu-time">
        <el-col :span="3">
          <span class="required-text">*</span>期望收货日期
        </el-col>
        <el-col :span="10">
          <el-date-picker
            v-model="orderForm.purchaseOrder.expectReceiveDate"
            type="date"
            placeholder="选择日期"
            :picker-options="timeOptions"
            clearable
            size="middle"
            class="time-picker"
          ></el-date-picker>
        </el-col>
      </el-row>-->

      <!-- 订单备注 -->
      <el-row class="non-menu-less non-menu-remark">
        <el-col :span="3">订单备注</el-col>
        <el-col :span="21">
          <el-input
            type="textarea"
            rows="3"
            resize="none"
            :maxlength="200"
            placeholder="最多可输入200个字符"
            show-word-limit
            v-model="orderForm.purchaseOrder.orderRemark"
          ></el-input>
        </el-col>
      </el-row>

      <el-row class="submit-btn" type="flex" justify="center">
        <el-button type="primary" class="btn-blue-plain-hover" @click="resetOrder">重置</el-button>
        <el-button type="primary" class="btn-blue-plain-hover" @click="saveOrder">保存</el-button>
        <el-button type="primary" class="btn-blue-plain-hover" @click="submitOrder">提交</el-button>
      </el-row>

      <!-- 地址弹窗 -->
      <!-- <el-dialog title="选择地址" :visible.sync="dialogVisible" :close-on-click-modal="false" width="40%">
        <div class="address-list">
          <div class="addrss-row">
            <el-card
              v-for="address in addressList"
              :key="address.addressId"
              shadow="never"
              class="address-card"
              :class="actived.addressId === address.addressId ? 'address-selected' : ''"
              @click.native="selecte(address)"
            >

              <el-col>
                <el-row class="info-row">
                  <el-col :span="4">收 货 人 :</el-col>
                  <el-col :span="20">{{ address.contactPerson }}</el-col>
                </el-row>
                <el-row class="info-row">
                  <el-col :span="4">联系方式 :</el-col>
                  <el-col :span="20">{{ maskMobileNo(address.contactMobile) }}</el-col>
                </el-row>
                <el-row class="info-row">
                  <el-col :span="4">收货地址 :</el-col>
                  <el-col :span="20">{{ composeAddressInfo(address) }}</el-col>
                </el-row>
              </el-col>
            </el-card>
          </div>
        </div>
        <div class="btn-row">
          <el-button class="btn-red" @click="confirmAddress">确认</el-button>
          <el-button class="btn-grey" @click="dialogVisible=false">取消</el-button>
        </div>
      </el-dialog>-->
    </div>

    <v-form ref="form" :url="exportUrl" :params="params" />
    <AddressForm ref="address-form" @success="queryAddressList" />
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import FileUpload from '@/components/file-upload'
import vForm from '@/components/v-form'
import ItemOrderBudgetPicker from './components/item-order-budget-picker'
import AddressForm from '../user/components/address-form'
import ItemOrderEntityPicker from './components/item-order-entity-picker'
import baseApi from '@/api/base'
import userApi from '@/api/user'
import { tokenUtils } from '@/utils/auth'
import { mapState, mapGetters } from 'vuex'
import { commonUtils } from '@/utils/common'
import formValidators from '@/utils/formValidators'
export default {
  name: 'NonMenuLess',
  components: {
    ContentHeader,
    ItemOrderBudgetPicker,
    ItemOrderEntityPicker,
    FileUpload,
    vForm,
    AddressForm
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget,
      NonMenuCodeList: state => state.base.nonMenuCodeTypeMap,
      taxRateList: state => state.base.taxRateFullNameMap,
      // addressOptions: state => state.base.sdAddress,
      subjectCategoryList: state => state.base.subjectCategoryMap
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    },
    total () {
      return this.deliveryListCopy.length || 0
    }
  },
  data () {
    return {
      // addressIndex: '',
      // orderAddressList: [],
      // actived: {},
      loading: false,
      uploadType: 0,
      exportUrl: commonUtils.getApiUrl('/purchase/detail/non-menu/export'),
      params: {},
      addressList: [],
      dialogVisible: false,
      brandList: [],
      channelList: [],
      deliveryList: [{
        itemCode: '',
        itemName: '',
        itemUnit: '',
        brand: [],
        abiBrandName: '',
        subBrandName: '',
        channel: [],
        channelName: '',
        subChannelName: '',
        applyPerson: '',
        m3Person: '',
        clientAddressId: '',
        provinceName: '',
        cityName: '',
        countyName: '',
        detailAddress: '',
        contactPerson: '',
        contactMobile: '',
        mmr12: '',
        ledgerAccount: '',
        subjectCategory: '',
        purchasePrice: undefined,
        purchaseQuantity: '',
        ledgerList: [],
        supplierName: '',
        // expectReceiveDate: '',
        // sdInfo: '',
        // addressInfo: '',
        // mmr12Type: '',
        // sdAddress: [],
        addressList: [{
          clientAddressId: '',
          purchaseQuantity: undefined
        }]
      }],
      deliveryListCopy: [],
      pocmList: [{
        itemCode: '',
        abiBrandName: '',
        subBrandName: '',
        taxExcludedPrice: '',
        itemName: '',
        itemUnit: '',
        produceSupplierName: '',
        channelName: '',
        subChannelName: '',
        taxCode: '',
        mmr12: '',
        ledgerAccount: '',
        subjectCategory: ''
      }],
      pocmListCopy: [],
      voucherFileList: [],
      orderForm: {
        deliveryList: [],
        pocmList: [],
        purchaseOrder: {
          orderType: '04',
          orderRemark: '',
          companyEntityId: '',
          costCenterId: '',
          trKhCode: '',
          orgCode: '',
          quotaId: '',
          voucherFiles: '',
          // expectReceiveDate: '',
          purchaseOrg: 'CNY3',
          orderDesc: '',
          sdCode: '',
          detailFile: ''
        }
      },
      fileList: [],
      produceSupplierList: [],
      mmr12List: [],
      unitList: [],
      isClear: false,
      channelTypeList: [{
        channelTypeName: '渠道',
        channelTypeId: '01'
      },
      {
        channelTypeName: '非渠道',
        channelTypeId: '02'
      }],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      timeOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      brandProps: {
        value: 'abiBrandName',
        label: 'brandAndGroup',
        children: 'subAbiBrandList',
        expandTrigger: 'hover'
      },
      channelProps: {
        value: 'channelName',
        label: 'channelName',
        children: 'subBaseChannelList',
        expandTrigger: 'hover'
      },
      page: 1,
      pageSize: 3
    }
  },
  watch: {
    'orderForm.purchaseOrder.companyEntityId' () {
      this.pocmList.forEach(item => {
        item.produceSupplierName = ''
      })
      this.getProduceSupplierList()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'nonMenuCodeTypeMap')
      this.$store.dispatch('getDictByName', 'subjectCategoryMap')
      this.$store.dispatch('getDictByName', 'taxRateFullNameMap')
      // this.$store.dispatch('getSdAddress')
      this.getAbiBrandList()
      this.getChannelList()
      this.getOrderLessCache()
      this.getMmr12List()
      this.queryAddressList()
      this.getUnitList()
      this.orderForm.purchaseOrder.sdCode = this.userInfo.orgDTO.sdCode
    },
    maskMobileNo: commonUtils.maskMobileNo,
    onBudgetPickerChanged (payload) {
      // TODO 处理payload
      this.orderForm.purchaseOrder.quotaId = payload.quotaId
      this.orderForm.purchaseOrder.orgCode = payload.orgCode
      this.orderForm.purchaseOrder.trKhCode = payload.trKhCode
    },

    onEntityPickerChanged (payload) {
      // TODO 处理payload
      this.orderForm.purchaseOrder.companyEntityId = payload.entityId
      this.orderForm.purchaseOrder.costCenterId = payload.costCenterId
      // this.orderForm.purchaseOrder.purchaseOrg = payload.purchaseOrg
    },

    // 校验数量
    checkQty (event) {
      let value = event.target.value
      if (value && !/^-?\d+$/.test(value)) {
        event.target.value = ''
        this.$message.warning('请输入整数')
      }
    },

    // composeAddressInfo (address) {
    //   if (!address) {
    //     return
    //   }
    //   let showInfo = ''
    //   showInfo += address.provinceName ? address.provinceName : ''
    //   showInfo += address.cityName ? ', ' + address.cityName : ''
    //   showInfo += address.countyName ? ', ' + address.countyName : ''
    //   showInfo += address.detailAddress ? ', ' + address.detailAddress : ''
    //   return showInfo
    // },

    // 获取生成供应商列表
    getProduceSupplierList () {
      baseApi.getSupplierByEntity(this.orderForm.purchaseOrder.companyEntityId).then(res => {
        if (res.data.resultCode === '0') {
          this.produceSupplierList = res.data.resultData.baseLogisticsSupplierList
        }
      })
    },
    // 获取品牌列表
    getAbiBrandList () {
      baseApi.getAbiBrandList().then(res => {
        if (res.data.resultCode === '0') {
          const brandVOList = res.data.resultData.brandVOList
          brandVOList.forEach((brand, index) => {
            // 设置子品牌下拉内容
            if (brand.subAbiBrandList && brand.subAbiBrandList.length) {
              // 子品牌具有品牌组才显示
              let arr = brand.subAbiBrandList.filter(subItem => {
                return subItem.brandGroup
              })
              brand.parentAbiBrand.subAbiBrandList = arr.length > 0 ? arr : null
            }

            // 组合显示主品牌
            this.$set(brand.parentAbiBrand, 'brandAndGroup', `${brand.parentAbiBrand.abiBrandName} ${brand.parentAbiBrand.brandGroup ? '-' : ''} ${brand.parentAbiBrand.brandGroup || ''}`)
            // 组合显示子品牌
            if (brand.parentAbiBrand.subAbiBrandList) {
              brand.parentAbiBrand.subAbiBrandList.forEach(subItem => {
                this.$set(subItem, 'brandAndGroup', `${subItem.abiBrandName} ${subItem.brandGroup ? '-' : ''} ${subItem.brandGroup || ''}`)
              })
            }

            this.brandList.push(brand.parentAbiBrand)
          })
        }
      })
    },
    // 获取渠道列表
    getChannelList () {
      baseApi.getChannelList().then(res => {
        if (res.data.resultCode === '0') {
          const channelVOList = res.data.resultData.baseChannelVOList
          channelVOList.forEach((channel, index) => {
            if (channel.subBaseChannelList && channel.subBaseChannelList.length) {
              channel.parentBaseChannel.subBaseChannelList = channel.subBaseChannelList
            }
            this.channelList.push(channel.parentBaseChannel)
          })
        }
      })
    },
    // 获取mmr12列表
    getMmr12List () {
      baseApi.getMmr12List().then(res => {
        if (res.data.resultCode === '0') {
          this.mmr12List = res.data.resultData.baseMmr12List
        }
      })
    },
    // 获取单位列表
    getUnitList () {
      baseApi.getUnitList().then(res => {
        if (res.data.resultCode === '0') {
          this.unitList = res.data.resultData.sapUnitList
        }
      })
    },
    // 获取缓存
    getOrderLessCache () {
      this.$store.dispatch('getOrderLessCache').then(response => {
        if (response.data.resultCode === '0' && response.data.resultData) {
          this.deliveryList = response.data.resultData.deliveryList
          this.pocmList = response.data.resultData.pocmList
          this.handleBrandAndChannel()
          // for (let i = 0; i < this.deliveryList.length; i++) {
          //   this.deliveryList[i].sdAddress = []
          //   this.deliveryList[i].sdAddress.push(this.deliveryList[i].sdId)
          //   this.deliveryList[i].sdAddress.push(this.deliveryList[i].addressId)
          // }
          this.deliveryList.forEach(item => {
            item.addressList.forEach(addressItem => {
              if (!addressItem?.purchaseQuantity) {
                addressItem.purchaseQuantity = undefined
              }
            })
          })
        }
      })
    },
    // 获取地址
    queryAddressList () {
      userApi.queryAddressList().then(res => {
        if (res.data.resultCode === '0') {
          this.addressList = res.data.resultData.addressList || []
        }
      })
    },

    // 增加行
    handleAddForm () {
      this.deliveryList.push(this.$options.data().deliveryList[0])
      this.pocmList.push(this.$options.data().pocmList[0])
    },
    // 删除行
    handleDeleteForm (index) {
      if (this.deliveryList.length > 1) {
        this.deliveryList.splice(index, 1)
        this.pocmList.splice(index, 1)
      }
    },
    // 添加地址
    addAddress (index) {
      this.deliveryList[index].addressList.push({
        clientAddressId: '',
        purchaseQuantity: undefined
      })
    },
    // 删除地址
    delAddress (index, addrIndex) {
      if (this.deliveryList[index].addressList.length === 1) {
        return
      }
      this.deliveryList[index].addressList.splice(addrIndex, 1)
    },
    // 验证地址数据完整
    checkAddressValue () {
      for (let i = 0; i < this.deliveryList.length; i++) {
        let tmpList = []
        for (let j = 0; j < this.deliveryList[i].addressList.length; j++) {
          let addressItem = this.deliveryList[i].addressList[j]
          if (tmpList.includes(addressItem.clientAddressId)) {
            this.$message.error(`物料 ${this.deliveryList[i].itemName} 下收货地址重复`)
            return false
          }
          if (!addressItem.clientAddressId) {
            this.$message.error(`请选择物料 ${this.deliveryList[i].itemName} 下收货地址 ${j + 1}`)
            return false
          }
          if (!addressItem.purchaseQuantity) {
            this.$message.error(`请填写物料 ${this.deliveryList[i].itemName} 下收货地址 ${j + 1} 物料数量`)
            return false
          }
          tmpList.push(addressItem.clientAddressId)
        }
      }
      this.composeValue()
      return true
    },
    // 组装数据
    composeValue () {
      let tmpDeliveryList = []
      this.deliveryList.forEach(delivery => {
        delivery.addressList.forEach(item => {
          if (item.clientAddressId && item.purchaseQuantity) {
            delivery.clientAddressId = item.clientAddressId
            delivery.purchaseQuantity = item.purchaseQuantity
            tmpDeliveryList.push(JSON.parse(JSON.stringify(delivery)))
          }
        })
      })
      this.orderForm.deliveryList = tmpDeliveryList
    },
    // 提交方式改变
    submitWayChange (value) {
      if (value === 1 && this.orderForm.purchaseOrder.companyEntityId === '') {
        this.$message.error('请先填写工厂并验证')
        this.uploadType = 0
        return
      }
      if (this.$refs.uploadOrderTemplate) {
        this.$refs.uploadOrderTemplate.clearFileList()
      }
      this.clearDataFile()
    },
    // 验证实体信息
    getEntityInfo () {
      if (!this.queryFrom.entityCode) {
        this.queryFrom.entityId = ''
        this.setValue()
        this.$message.error('请输入工厂Code')
        return
      }
      this.$store.dispatch('getEntityInfo', this.queryFrom.entityCode).then(res => {
        if (res.data.resultCode === '0') {
          if (!res.data.resultData.companyEntityDTO) {
            this.$message.error('无此工厂')
            this.queryFrom.entityId = ''
          } else {
            this.queryFrom.entityId = res.data.resultData.companyEntityDTO.entityId
          }
          this.setValue()
        }
      })
    },
    // 下载模板文件
    downloadTemplate () {
      this.params = {
        entityId: this.orderForm.purchaseOrder.companyEntityId
      }
      this.$refs.form.submit()
    },
    // 上传订单模板文件
    getDataFile (file) {
      this.isClear = false
      let params = {
        dataFileId: file.fileId,
        entityId: this.orderForm.purchaseOrder.companyEntityId
      }
      this.$store.dispatch('importOrderNonMenu', params).then(res => {
        if (res.data.resultCode === '0') {
          this.deliveryListCopy = res.data.resultData.deliveryList
          this.deliveryList = res.data.resultData.deliveryList.slice(0, this.pageSize)
          this.pocmListCopy = res.data.resultData.pocmList
          this.pocmList = res.data.resultData.pocmList.slice(0, this.pageSize)
          this.orderForm.purchaseOrder.detailFile = file.fileId
          this.handleBrandAndChannel()
          this.$message.success('上传成功')
          this.isClear = false
        } else {
          this.isClear = true
          this.$message.error('上传失败：' + res.data.resultMsg)
          this.$refs.uploadOrderTemplate.clearFileList()
        }
      })
    },
    // 删除模板文件
    clearDataFile () {
      this.deliveryList = this.$options.data().deliveryList
      this.deliveryListCopy = []
      this.pocmList = this.$options.data().pocmList
      this.pocmListCopy = []
      this.page = 1
    },

    // 选择地址
    // selectAdress (index) {
    //   this.dialogVisible = true
    //   this.addressIndex = index
    //   this.getAddressList()
    // },
    // 获取地址信息
    // getAddressList () {
    //   userApi.queryAddressList().then(res => {
    //     if (res.data.resultCode === '0') {
    //       this.addressList = res.data.resultData.addressList || []
    //       if (this.addressList.length) {
    //         this.addressSelected = this.addressList[0]
    //         this.orderAddressList.push(this.addressSelected)
    //       }
    //     }
    //   })
    // },
    // 切换地址
    // changeAddress () {
    //   this.dialogVisible = true
    //   this.actived = this.addressSelected
    // },
    // selecte (address) {
    //   this.actived = address
    // },
    // confirmAddress () {
    //   const index = this.addressIndex
    //   this.orderAddressList = []
    //   this.dialogVisible = false
    //   this.deliveryList[index].receivePerson = this.actived.contactPerson
    //   this.deliveryList[index].receivePhone = this.actived.contactMobile
    //   this.deliveryList[index].provinceName = this.actived.provinceName
    //   this.deliveryList[index].cityName = this.actived.cityName
    //   this.deliveryList[index].countyName = this.actived.countyName
    //   this.deliveryList[index].detailAddress = this.actived.detailAddress
    // },

    // 上传文件成功的钩子
    handleUploadSuccess (response, file, fileList) {
      if (response.resultCode === '0') {
        this.voucherFileList.push(response.resultData.fileDTO.fileId)
      } else {
        this.$message.error({ message: response.resultMsg, showClose: true })
        fileList.pop()
      }
    },
    // 文件超出个数限制时的钩子
    handleTemplateExceed (files, fileList) {
      if (fileList.length >= 1) {
        this.$alert('不能上传超过1个文件', '提示')
      }
    },
    // 移除上传凭证
    handleFileRemove (file) {
      if (file) {
        baseApi.deleteFile({ fileId: file.response.resultData.fileDTO.fileId }).then((res) => {
          if (res.data.resultCode === '0') {
            this.voucherFileList.forEach((item, index) => {
              if (item === file.response.resultData.fileDTO.fileId) {
                this.voucherFileList.splice(index, 1)
              }
            })
          }
        })
      }
    },
    // 提交订单
    submitOrder () {
      if (this.orderForm.purchaseOrder.quotaId === '' && this.orderForm.purchaseOrder.trKhCode === '') {
        this.$message.error('请选择预算')
        return
      }
      if (this.orderForm.purchaseOrder.companyEntityId === '') {
        this.$message.error('请填写工厂Code并验证')
        return
      }
      if (this.orderForm.purchaseOrder.costCenterId === '') {
        this.$message.error('请填写成本中心Code并验证')
        return
      }
      if (!this.orderForm.purchaseOrder.purchaseOrg) {
        this.$message.error('请选择采购组织')
        return
      }
      if (!this.orderForm.purchaseOrder.orderDesc) {
        this.$message.error('请输入订单描述')
        return
      }

      // if (!this.orderForm.purchaseOrder.expectReceiveDate) {
      //   this.$message.error('请选择期望收货日期')
      //   return
      // }

      // if (!this.orderForm.purchaseOrder.sdCode) {
      //   this.$message.error('请选择SD Code')
      //   return
      // }
      // if (this.voucherFileList.length <= 0) {
      //   this.$message.error('请上传比价凭证')
      //   return
      // }
      this.paramAssign()
      if (!this.formVerification()) {
        return
      }
      if (this.uploadType === 0 && !this.checkAddressValue()) {
        return
      }
      this.loading = true
      this.$store.dispatch('createOrderLess', this.orderForm).then(response => {
        if (response.data.resultCode === '0') {
          this.loading = false
          this.$router.replace({
            path: '/material/item-order-success',
            query: { orderNumber: response.data.resultData.orderNumber }
          })
        } else {
          this.loading = false
          if (this.uploadType !== 1) return
          this.$refs.uploadOrderTemplate.clearFileList()
          this.clearDataFile()
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('提交失败')
      })
    },
    // 填写参数校验
    formVerification () {
      if (this.uploadType === 1) return true
      for (let i = 0; i < this.deliveryList.length; i++) {
        if (!this.deliveryList[i].itemCode) {
          this.$message.error('请选择物料编码')
          return false
        }
        if (!this.deliveryList[i].itemName) {
          this.$message.error('请输入物料名称')
          return false
        }
        if (!this.deliveryList[i].purchasePrice && this.deliveryList[i].purchasePrice !== 0) {
          this.$message.error('请输入单价')
          return false
        }
        if (!this.deliveryList[i].itemUnit) {
          this.$message.error('请选择单位')
          return false
        }
        // if (!this.deliveryList[i].purchaseQuantity) {
        //   this.$message.error('请输入数量')
        //   checkResult = false
        // }
        if (!this.deliveryList[i].mmr12) {
          this.$message.error('请选择mmr12')
          return false
        }
        if (!this.deliveryList[i].ledgerAccount) {
          this.$message.error('请选择总账科目')
          return false
        }
        if (!this.deliveryList[i].brand.length) {
          this.$message.error('请选择品牌')
          return false
        }
        if (!this.deliveryList[i].channel.length) {
          this.$message.error('请选择渠道')
          return false
        }
        if (!this.deliveryList[i].applyPerson) {
          this.$message.error('请填写申请人')
          return false
        }
        if (!this.deliveryList[i].m3Person) {
          this.$message.error('请填写M3')
          return false
        }
        // if (!this.deliveryList[i].clientAddressId) {
        //   this.$message.error('请选择交货地址')
        //   checkResult = false
        // }
      }
      for (let i = 0; i < this.pocmList.length; i++) {
        if (!this.pocmList[i].subjectCategory) {
          this.$message.error('请选择科目分配类别')
          return false
        }
        if (!this.pocmList[i].taxCode) {
          this.$message.error('请选择税码')
          return false
        }
        if (!this.pocmList[i].produceSupplierName) {
          this.$message.error('请选择供应商')
          return false
        }
      }
      return true
    },
    // 保存订单
    saveOrder () {
      if (this.uploadType === 1) {
        this.$message.warning('仅限在线填写时保存')
        return
      }
      this.paramAssign()
      this.orderForm.deliveryList = this.deliveryList
      this.$store.dispatch('saveOrderLess', this.orderForm).then(response => {
        if (response.data.resultCode === '0') {
          this.$message.success('保存成功')
        }
      })
    },
    // 重置订单
    resetOrder () {
      this.$store.dispatch('resetOrderLessCache').then(response => {
        if (response.data.resultCode === '0') {
          this.$message.success('重置成功')
          this.clearDataFile()
          this.$refs.uploadOrderTemplate.clearFileList()
        }
      })
    },
    // 给参数赋值
    paramAssign (type) {
      this.orderForm.purchaseOrder.voucherFiles = ''
      this.voucherFileList.forEach(item => {
        this.orderForm.purchaseOrder.voucherFiles += item + ','
      })
      if (this.uploadType === 1) {
        this.deliveryList = this.deliveryListCopy
        this.pocmList = this.pocmListCopy
      }
      for (let i = 0; i < this.deliveryList.length; i++) {
        if (this.uploadType === 1) {
          this.deliveryList = this.deliveryListCopy
          this.pocmList = this.pocmListCopy
        }
        this.deliveryList[i].abiBrandName = this.deliveryList[i].brand ? this.deliveryList[i].brand[0] : this.deliveryList[i].abiBrandName
        this.deliveryList[i].subBrandName = this.deliveryList[i].brand ? this.deliveryList[i].brand[1] : this.deliveryList[i].subBrandName
        this.deliveryList[i].channelName = this.deliveryList[i].channel ? this.deliveryList[i].channel[0] : this.deliveryList[i].channelName
        this.deliveryList[i].subChannelName = this.deliveryList[i].channel ? this.deliveryList[i].channel[1] : this.deliveryList[i].subChannelName
        this.deliveryList[i].supplierName = this.pocmList[i].produceSupplierName
        this.pocmList[i].itemCode = this.deliveryList[i].itemCode
        this.pocmList[i].channelName = this.deliveryList[i].channelName
        this.pocmList[i].subChannelName = this.deliveryList[i].subChannelName
        this.pocmList[i].itemName = this.deliveryList[i].itemName
        this.pocmList[i].itemUnit = this.deliveryList[i].itemUnit
        this.pocmList[i].taxExcludedPrice = this.deliveryList[i].purchasePrice
        this.pocmList[i].abiBrandName = this.deliveryList[i].abiBrandName
        this.pocmList[i].subBrandName = this.deliveryList[i].subBrandName
        this.pocmList[i].mmr12 = this.deliveryList[i].mmr12
        this.pocmList[i].ledgerAccount = this.deliveryList[i].ledgerAccount
        // this.pocmList[i].subjectCategory = this.deliveryList[i].subjectCategory
        // if (this.uploadType === 0) {
        //   this.deliveryList[i].sdId = this.deliveryList[i].sdAddress[0]
        //   this.deliveryList[i].addressId = this.deliveryList[i].sdAddress[1]
        // }
      }
      if (this.uploadType === 1) {
        this.orderForm.deliveryList = this.deliveryList
      }

      this.orderForm.pocmList = this.pocmList
    },

    // mmr12输入
    mmrInput (index) {
      this.deliveryList[index].ledgerAccount = ''
      this.deliveryList[index].ledgerList = []
      if (!this.deliveryList[index].mmr12) {
        return
      }
      this.getLedgerList(index)
    },

    // 总账科目
    getLedgerList (index) {
      baseApi.getLedgerList(this.deliveryList[index].mmr12).then(res => {
        if (res.data.resultCode === '0') {
          this.deliveryList[index].ledgerList = res.data.resultData.ledgerList
          if (this.deliveryList[index].ledgerList.length === 1) {
            this.deliveryList[index].ledgerAccount = this.deliveryList[index].ledgerList[0].ledgerAccountCode
          }
        }
      })
    },

    // 处理品牌及渠道
    handleBrandAndChannel () {
      for (let i = 0; i < this.deliveryList.length; i++) {
        this.deliveryList[i].brand = []
        this.deliveryList[i].brand.push(this.deliveryList[i].abiBrandName)
        this.deliveryList[i].brand.push(this.deliveryList[i].subBrandName)
        this.deliveryList[i].channel = []
        this.deliveryList[i].channel.push(this.deliveryList[i].channelName)
        this.deliveryList[i].channel.push(this.deliveryList[i].subChannelName)
      }
    },
    toAdd () {
      const addressForm = { action: 'create' }
      this.$refs['address-form'].show(addressForm)
    },
    // 分页
    handleCurrentChange (val) {
      this.handlePagination(val)
    },
    handlePagination (page) {
      this.deliveryList = this.deliveryListCopy.slice((page - 1) * this.pageSize, page * this.pageSize)
      this.pocmList = this.pocmListCopy.slice((page - 1) * this.pageSize, page * this.pageSize)
    },
    checkPurchasePrice (value,index) {
      if (Number(value) < 0 || !/^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,3}\b)/.test(value)) {
        this.$message.warning('请输入非负且最多包含三位小数的数字')
      }
      this.deliveryList[index].purchasePrice = this.setToFixed(value)
    },
    setToFixed (num) {
      if (Math.ceil(num) > 0) {
        return Number(num).toFixed(3)
      }
      return num === 0 ? 0 : undefined
    },
  }
}
</script>

<style lang="scss" scoped>
.non-menu-less,
.non-menu-desc {
  min-width: 100%;
  margin-bottom: 15px;
  background-color: #fff;
  & > .el-col {
    padding: 0 20px;
    border-radius: 8px;
    background-color: $base-white;
  }
  border-radius: 8px;
}
.non-menu-desc {
  height: 80px;
  padding-top: 30px;
}
.less-first-row {
  .el-col {
    height: 205px;
  }
  .upload-certificate-col {
    width: 30%;
    line-height: 180px;
    margin-right: 15px;
  }
  .entity-picker-col {
    width: 68.7%;
    .el-col {
      line-height: 180px;
    }
  }
}
.item-info-box {
  height: 100%;
  .item-submit-way {
    height: 60px;
    padding-top: 10px;
    line-height: 60px;
    .item-info-title {
      // display: inline-block;
      padding-right: 40px;
    }
    div:last-child {
      display: inline-block;
    }
    .el-button {
      margin-right: 10px;
    }
  }
  .item-info-form {
    padding-bottom: 10px;
    .info-form-head {
      height: 50px;
      line-height: 50px;
      margin-bottom: 16px;
      text-align: center;
      background-color: $base-grey6;
      .el-col {
        min-width: 80px;
        .el-button {
          min-width: 20px;
        }
      }
      .info-form-price {
        line-height: 25px;
      }
      .info-form-produce {
        padding-left: 10px;
      }
    }
    .table-input-row {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .require-text {
        color: red;
        padding-right: 2px;
      }
      .create-text {
        color: $base-blue;
        cursor: pointer;
        margin-top: -5px;
        margin-left: 7px;
        font-size: 12px;
      }
    }
    .info-form-detail {
      position: relative;
      padding: 20px 0;
      .el-col {
        line-height: 40px;
      }
      .btn-function {
        position: absolute;
        top: 50%;
        right: 0;
      }
      .info-form-input {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        padding: 0 3px;
        margin-bottom: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        background-color: #f5f7fa;
        border: 1px solid #e4e7ed;
        border-radius: 5px;
        color: #c0c4cc;
      }
      .el-input-number {
        display: inline-block;
        width: 100%;
        ::v-deep .el-input-number__decrease,
        ::v-deep .el-input-number__increase {
        display: none;
      }
  }
    }
    .split-line {
      height: $content-middle;
      border-bottom: 1px dashed #353535;
    }
  }
}
.non-menu-time {
  padding-top: 30px;
  height: 100px;
  .el-col-3 {
    padding-top: 12px;
  }
}
.non-menu-remark {
  padding-top: 30px;
  height: 130px;
}
.submit-btn {
  margin-top: $page-middle;
  text-align: center;
  .el-button {
    width: 180px;
  }
}

.iconzu111 {
  font-size: 17px;
}
.Stepper {
  margin-left: 5px;
  // margin-right: 20px;
  border-color: white;
  ::v-deep .el-input__inner {
    width: 110px;
    padding: 0;
  }

  .el-input-number {
    width: 110px;
  }
}
.danger-btn {
  cursor: pointer;
  line-height: 40px;
  font-size: 26px;
  color: #c8102d;
}
.addAddress {
  cursor: pointer;
  color: $base-blue;
  line-height: 40px;
  font-size: 26px;
  margin-left: 5px;
}
</style>
